const EXAMPLE_YEAR = 2000;
const EXAMPLE_MONTH = 11;
const EXAMPLE_DAY = 31;

/**
 * @returns A locale-aware date placeholder string, e.g. "DD/MM/YYYY" or "MM/DD/YYYY".
 */
export function DatePlaceholder() {
  // Use an example date to derive the pattern
  const exampleDate = new Date(EXAMPLE_YEAR, EXAMPLE_MONTH, EXAMPLE_DAY);
  const formatter = new Intl.DateTimeFormat(undefined, {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  });
  const parts = formatter.formatToParts(exampleDate);

  const placeholder = parts
    .map((p) => {
      switch (p.type) {
        case "day":
          return "DD";
        case "month":
          return "MM";
        case "year":
          return "YYYY";
        default:
          return p.value;
      }
    })
    .join("");

  return <span>{placeholder}</span>;
}
